export default {
  rooms: {
    // [presentationId]: { id: [roomId] }
    p01_ako_ucit_dieta: { id: '0' },
    p02_kroky_k_uspechu: { id: '0' },
    p03_vyvin_pohyb: { id: '0' },
    p04_o_odnimani_zodpovednosti: { id: '0' },
    p05_zdrava_strava: { id: '0' },
    p06_koreny_zavislosti: { id: '0' },
    p07_mozek_jsme_my: { id: '0' },
    p08_telo_a_mozek: { id: '0' },
    p09_co_jedia: { id: '0' },
    p10_v_ucitelskych_monterkach: { id: '0' },
    c01_encounter: { id: '0' },
    c02_panelova_diskusia: { id: '0' },
    c03_workshops_sobota: { id: '0' },
    c05_workshops_nedela: { id: '0' },
    c04_pecha_kucha: { id: '0' },
  },
}



// WEBPACK FOOTER //
// ./src/content/devdata/addons/chat/presentation.js